// removed by extract-text-webpack-plugin
module.exports = {"auctioneer-info":"auctioneer-info___rZQcY","details":"details___1bsrg","flag-name":"flag-name___2wGUI","flag":"flag___2nZyX","name":"name___pJ4S8","question":"question___2lwzS","image-container":"image-container___1MveE","image":"image___13AbE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AuctioneerInfo/AuctioneerInfo.scss
// module id = mHb4
// module chunks = 46